export const interpretations = [
  {
    id: 1,
    title: "从少女到母亲：林晚的三次转身",
    excerpt:
      "《年轻的母亲》最动人的，不是苦难本身，而是一个女孩在命运面前一次次主动站起来的姿态。我们用三个关键词拆解林晚的成长弧光。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20still%20of%20a%20young%20woman%20standing%20at%20a%20window%20in%20thoughtful%20profile%2C%20soft%20golden%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20color%20grading%2C%20reflective%20mood&width=480&height=320&seq=young-mother-read01&orientation=landscape",
    date: "2025-05-20",
    author: "剧评人 · 舒桐",
    episodeRef: 1,
    tag: "人物分析",
  },
  {
    id: 2,
    title: "沉默的母亲：苏敏这个角色为什么让人又爱又恨",
    excerpt:
      "她固执、唠叨、不善表达，却在最要紧的关头挡在女儿身前。苏敏的沉默里，藏着中国式母亲最普遍的爱与局限。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20still%20of%20an%20elderly%20chinese%20mother%20in%20a%20kitchen%20wiping%20her%20hands%2C%20soft%20warm%20lamplight%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20quiet%20emotion&width=480&height=320&seq=young-mother-read02&orientation=landscape",
    date: "2025-05-18",
    author: "剧评人 · 陆沉",
    episodeRef: 4,
    tag: "人物分析",
  },
  {
    id: 3,
    title: "雨夜那场戏，是全剧的情绪分水岭",
    excerpt:
      "第10集的雨夜争执常被观众反复回看。为什么一场看似普通的争吵，能成为整部剧的情感转折点？我们从镜头语言说起。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20still%20of%20rain%20falling%20on%20a%20night%20city%20street%20with%20warm%20streetlights%20and%20bokeh%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20melancholic%20mood&width=480&height=320&seq=young-mother-read03&orientation=landscape",
    date: "2025-05-15",
    author: "影评专栏 · 顾南",
    episodeRef: 10,
    tag: "镜头解读",
  },
  {
    id: 4,
    title: "『家在哪里』：结局想告诉我们的那件事",
    excerpt:
      "大结局没有给出标准答案，而是把选择权交还给了人物。关于归属与和解，这部剧给出了比团圆更高级的表达。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20still%20of%20a%20warm%20lit%20home%20window%20at%20evening%20with%20silhouette%2C%20soft%20amber%20glow%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20hopeful%20mood&width=480&height=320&seq=young-mother-read04&orientation=landscape",
    date: "2025-05-19",
    author: "剧评人 · 舒桐",
    episodeRef: 23,
    tag: "结局解读",
  },
  {
    id: 5,
    title: "被忽略的配角：邻居沈知远为何如此治愈",
    excerpt:
      "他不是男主，却承包了全剧最多次的温柔。沈知远这个角色，如何用克制的善意改变了林晚的处境？",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20still%20of%20a%20calm%20young%20man%20in%20a%20soft%20sweater%20by%20a%20sunlit%20window%2C%20warm%20afternoon%20light%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20gentle%20mood&width=480&height=320&seq=young-mother-read05&orientation=landscape",
    date: "2025-05-12",
    author: "角色研究 · 何岸",
    episodeRef: 6,
    tag: "角色研究",
  },
  {
    id: 6,
    title: "从产检单到屋顶星空：剧中反复出现的意象",
    excerpt:
      "产检单、旧照片、一盏留着的灯……这些被重复使用的意象，构成了《年轻的母亲》细腻的情感密码。",
    cover:
      "https://readdy.ai/api/search-image?query=warm%20cinematic%20editorial%20still%20of%20a%20starry%20night%20sky%20above%20a%20quiet%20rooftop%20with%20warm%20city%20bokeh%2C%20gentle%20film%20grain%2C%20shallow%20depth%20of%20field%2C%20muted%20warm%20tones%2C%20dreamy%20nostalgic%20mood&width=480&height=320&seq=young-mother-read06&orientation=landscape",
    date: "2025-05-16",
    author: "影评专栏 · 顾南",
    episodeRef: 21,
    tag: "意象解读",
  },
];